<template>
  <div class="business-pool">
    <div class="card-panel">
      <div class="biz-selectors">
        <div class="biz-selectors__item">
          <label class="field-label">选择归属公司</label>
          <el-select
            v-model="selectedCompany"
            placeholder="请选择公司"
            filterable
            size="medium"
            style="width: 100%"
            @change="onCompanyChange(null)"
          >
            <el-option
              v-for="co in companyList"
              :key="co.id"
              :label="`${co.companyName}`"
              :value="co.id"
            ></el-option>
          </el-select>
        </div>
        <div class="biz-selectors__arrow">
          <i class="el-icon-arrow-right" style="font-size:24px;color:#a855f7"></i>
        </div>
        <div class="biz-selectors__item">
          <label class="field-label">选择业务子类型</label>
          <el-select
            v-model="selectedBizType"
            placeholder="请选择业务子类型"
            filterable
            size="medium"
            @change="onGroupChange"
            style="width:100%"
          >
            <el-option
              v-for="bt in bizTypeList"
              :key="bt.id"
              :label="`${bt.groupName}（${bt.isGroupLabelOpen ? '已开启' : '未开启'}）`"
              :value="bt.id"
            >
              <span>{{ bt.groupName }}</span>
              <span
                class="biz-option__status"
                :class="bt.isGroupLabelOpen ? 'biz-option__status--on' : 'biz-option__status--off'"
              >（{{ bt.isGroupLabelOpen ? '已开启' : '未开启' }}）</span>
            </el-option>
          </el-select>
        </div>
        <div class="biz-selectors__item">
          <label class="field-label">是否{{ currentGroup.isGroupLabelOpen ? '关闭' : '开启' }}业务标签池</label>
          <el-switch
            v-model="currentGroup.isGroupLabelOpen"
            size="medium"
            :disabled="groupStatusUpdating"
            @change="updateGroupLabelStatus"
            style="width:100%"
          ></el-switch>
        </div>
      </div>
    </div>

    <div class="biz-stat-card">
      <div class="biz-stat-card__info">
        <h3 class="biz-stat-card__title">{{ currentGroup.groupName || '业务池' }}</h3>
        <div class="biz-stat-card__company">
          <i class="el-icon-office-building"></i>
          <span>{{ currentCompany.companyName }}</span>
        </div>
      </div>
      <div class="biz-stat-card__count">
        <div class="biz-stat-card__number">{{ tags.length }}</div>
        <div class="biz-stat-card__label">个标签</div>
      </div>
    </div>

    <div class="pool-toolbar">
      <div class="pool-toolbar__left">
        <el-input
          v-model="searchKeyword"
          :placeholder="sortMode ? '排序模式下展示全部标签' : '搜索业务池内的标签...'"
          prefix-icon="el-icon-search"
          clearable
          size="medium"
          :disabled="sortMode"
          style="width: 300px"
        ></el-input>
        <span class="source-count">共 {{ filteredTags.length }} 个标签</span>
      </div>
      <div class="pool-toolbar__right">
        <div class="source-filter-btns">
          <button
            v-for="sf in sourceFilters"
            :key="sf.key"
            class="source-filter-btn"
            :class="{ 'source-filter-btn--active': sourceFilter === sf.key }"
            :disabled="sortMode"
            @click="sourceFilter = sf.key"
          >{{ sf.label }}</button>
        </div>
        <span class="sort-label">排序模式</span>
        <el-switch v-model="sortMode"></el-switch>
        <el-button type="primary" icon="el-icon-plus" :loading="pickLoading" @click="openPickCompany">从公司池选用</el-button>
      </div>
    </div>

    <div v-if="sortMode" class="sort-hint">
      <span>正在优化业务池标签优先级链条...</span>
      <div>
        <el-button size="mini" @click="reorderAll">序号重排</el-button>
        <el-button size="mini" type="primary" :loading="sortSaving" @click="saveSort">保存更新</el-button>
      </div>
    </div>

    <div class="pool-table-header">
      <div class="pool-table-header__col pool-table-header__col--30">
        <span class="pool-table-header__rank">序号</span>
        <span>标签名称 / 优先级 / 来源 / 主标签</span>
      </div>
      <div class="pool-table-header__col pool-table-header__col--20">业务类型 / 状态</div>
      <div class="pool-table-header__col pool-table-header__col--15">案件状态 / 联系状态</div>
      <div class="pool-table-header__col pool-table-header__col--35 pool-table-header__col--right">ID / 标签描述 / 操作</div>
    </div>

    <div class="pool-list">
      <tag-card
        v-for="(tag, idx) in filteredTags"
        :key="tag.id"
        :tag="tag"
        :index="idx"
        pool-type="business"
        :sort-mode="sortMode"
        :parent-tag-name="getParentName(tag.parentTagId)"
        @edit="openEditDialog"
        @delete="deleteTag"
        @move="moveTag"
        @jump-to="jumpTo"
        @drag-drop="onDragDrop"
      ></tag-card>
    </div>

    <tag-form-dialog
      ref="tagFormDialog"
      pool-type="business"
      :all-tags="tags"
      :edit-tag="currentEditTag"
      :filtered-tags="filteredTags"
      :company-business-type="currentCompany ? currentCompany.businessType: ''"
      :case-status-option="caseStatusOption"
      :contact-status-option="contactStatusOption"
      @confirm="onFormConfirm"
    ></tag-form-dialog>

    <pick-company-dialog
      ref="pickCompanyDialog"
      :company-tags="companyPoolTags"
      :company-name="currentCompany.companyName"
      :biz-type="currentGroup.groupName"
      :configured-ids="configuredBizTagIds"
      @confirm="onPickCompanyConfirm"
    ></pick-company-dialog>
  </div>
</template>

<script>
import TagCard from './tag-card';
import TagFormDialog from './tag-form-dialog';
import PickCompanyDialog from './pick-company-dialog';
import TagPoolMixin from './tag-pool-mixin';

export default {
  name: 'BusinessPool',
  components: { TagCard, TagFormDialog, PickCompanyDialog },
  // 复用标签池公共逻辑（删除标签、上下文校验）
  mixins: [TagPoolMixin],
  props: {
    tags: { type: Array, default: () => [] },
    companyList: { type: Array, default: () => [] },
    // 是否处于业务标签页（父级点击“业务标签”tab 时置为 true）
    active: { type: Boolean, default: false },
    // 父级记录的最近一次选中的公司 id 与其业务类型（切 tab 后不丢失）
    savedCompany: { type: [Number, String], default: null },
    caseStatusOption: { type: Array, default: () => [] },
    contactStatusOption: { type: Array, default: () => [] }
  },
  data() {
    return {
      selectedCompany: null,
      selectedBizType: null,
      selectGroupLabelStatus: false,
      selectedGroupName: '',
      searchKeyword: '',
      sourceFilter: 'all',
      sourceFilters: [
        { key: 'all', label: '全部' },
        { key: 'general', label: '来源通用' },
        { key: 'company', label: '来源公司' }
      ],
      sortMode: false,
      // 进入页面时清除排序模式，此期间的 sortMode 变化不再触发重新拉取
      sortModeResetting: false,
      currentEditTag: null,
      groupReq: {
        companyId: ''
      },
      bizTypeList: [],
      // 已进入业务 tab 但公司列表尚未返回，等待 companyList 就绪后补执行
      pendingEnter: false,
      isOwnMode: false,
      // 弹窗数据源：每次点开时按当前公司实时拉取
      companyPoolTags: [],
      pickLoading: false,
      // 排序保存中（防重复提交 + 按钮 loading）
      sortSaving: false,
      // 业务标签池开关保存中（防重复提交 + 禁用开关）
      groupStatusUpdating: false
    };
  },
  watch: {
    // 每次点击业务标签 tab（active 变为 true）都执行 onCompanyChange：
    // 优先恢复父级记录的已选公司，无记录则默认选第一家
    active: {
      immediate: true,
      handler(val) {
        if (val) this.enterBusiness();
      }
    },
    // 兜底：业务 tab 已激活但公司列表接口返回较晚，列表就绪后补执行一次
    companyList() {
      if (this.active && this.pendingEnter) this.enterBusiness();
    },
    // 进入排序模式时重置搜索与来源筛选，保证排序针对全量数据
    sortMode(val) {
      if (val) {
        this.sourceFilter = 'all';
        this.searchKeyword = '';
        return;
      }
      // 进入页面时只是清除排序模式，数据由进入流程统一刷新，避免重复请求与“序号已恢复”提示
      if (this.sortModeResetting) return;
      this.reorderAll();
    },
    // 业务池列表或开关状态变化时上报"已开启标签的业务池个数"，供父级头部统计与 tab 角标使用
    bizTypeList: {
      deep: true,
      handler(list) {
        this.$emit('biz-open-count-change', (list || []).filter(item => item.isGroupLabelOpen).length);
      }
    }
  },
  computed: {
    currentCompany() {
      return this.companyList.find(c => c.id === this.selectedCompany) || null;
    },
    currentGroup() {
      return this.bizTypeList.find(c => c.id === this.selectedBizType);
    },
    allTags() {
      const list = this.tags || [];
      return list
        .map(t => ({
          ...t,
          source: Number(t.isCommon) === 0 ? '来源公司' : '来源通用'
        }))
        .sort((a, b) => a.priority - b.priority);
    },
    configuredBizTagIds() {
      return this.tags.map(t => t.detailId);
    },
    filteredTags() {
      // 排序模式下必须展示全部数据：搜索与来源筛选均不生效
      if (this.sortMode) return this.allTags;
      let list = this.allTags;
      if (this.searchKeyword) {
        const kw = this.searchKeyword.toLowerCase();
        list = list.filter(t =>
          t.name.toLowerCase().includes(kw) ||
          t.code.toLowerCase().includes(kw)
        );
      }
      if (this.sourceFilter === 'general') {
        list = list.filter(t => t.source === '来源通用');
      } else if (this.sourceFilter === 'company') {
        list = list.filter(t => t.source === '来源公司');
      }
      return list;
    }
  },
  methods: {
    getParentName(parentId) {
      if (!parentId) return null;
      const parent = this.tags.find(t => t.id === parentId);
      return parent ? parent.name : null;
    },
    openEditDialog(tag) {
      this.currentEditTag = tag;
      this.$refs.tagFormDialog.open();
    },
    // 保存成功后的刷新：弹窗已提示，这里只重置编辑态并通知父级按当前公司与策略组重新拉取，
    // 保证列表以后端返回为准（本地对象是 computed 生成的副本，直接改不会触发渲染）
    onFormConfirm() {
      this.currentEditTag = null;
      this.onGroupChange();
    },
    // 删除成功后的刷新：通知父级按当前公司与策略组重新拉取业务标签
    onTagDeleted() {
      this.onGroupChange();
    },
    // 每次点开“从公司池选用”弹窗：按当前选中公司实时拉取公司标签
    openPickCompany() {
      if (this.selectedCompany == null) {
        this.$message.warning('请先选择归属公司');
        return;
      }
      if (this.pickLoading) return;
      this.pickLoading = true;
      this.$ajax({
        url: '/label/list',
        method: 'post',
        data: this.buildLabelListParam('', this.selectedCompany, 0)
      })
        .then((res) => {
          const list = res.data.list || [];
          // 与公司池口径一致：接口暂未返回来源字段，统一按“来自通用池”打标
          this.companyPoolTags = list.map(item => ({ ...item, source: '来源通用' }));
          // 显式把最新数据传给弹窗：props 需等下次渲染才更新，直接 open() 会读到旧值
          this.$refs.pickCompanyDialog.open(this.companyPoolTags);
        })
        .catch(() => {
          this.companyPoolTags = [];
          this.$message.error('公司标签加载失败');
        })
        .finally(() => {
          this.pickLoading = false;
        });
    },
    buildLabelListParam(typeFilter, companyId, groupId) {
      return {
        'companyId': companyId,
        'groupId': groupId,
        'label': null,
        'mainStrategy': null,
        'caseStatusList': null,
        'labelStatus': null,
        'businessType': typeFilter,
        'page': 1,
        'limit': 0,
        'order': 'priority',
        'sort': 'asc'
      };
    },
    // 批量提交标签到当前业务池（目标公司 + 目标策略组），供「从公司池选用」与「排序保存」复用
    // detailIds 的数组顺序即优先级顺序；loadingKey 指定各自按钮的 loading 字段
    submitLabelBatch(detailIds, { successMessage, emptyMessage, loadingKey, onSuccess }) {
      if (!this.checkBatchContext()) return;

      const ids = (detailIds || []).filter(id => id !== undefined && id !== null);
      if (!ids.length) {
        this.$message.info(emptyMessage || '没有可提交的标签');
        return;
      }
      if (loadingKey && this[loadingKey]) return;
      if (loadingKey) this[loadingKey] = true;

      this.$ajax({
        url: '/label/addOrEditLabelBatch',
        method: 'POST',
        data: {
          // 目标公司
          companyId: this.selectedCompany,
          // 目标策略组
          groupId: this.selectedBizType,
          // 来源公司（标签取自该公司 groupId=0 的标签池）
          sourceCompanyId: this.selectedCompany,
          // 待提交的标签明细 id 集合
          detailIds: ids
        }
      })
        .then(() => {
          this.$message.success(successMessage);
          if (onSuccess) onSuccess();
          // 通知父级按当前公司与策略组重新拉取业务标签
          this.onGroupChange();
        })
        .catch(() => {})
        .finally(() => {
          if (loadingKey) this[loadingKey] = false;
        });
    },
    // 从公司池选用标签确认：批量新增到当前业务池
    onPickCompanyConfirm(selected) {
      this.submitLabelBatch(
        (selected || []).map(t => t.detailId),
        {
          successMessage: '已添加至业务池',
          emptyMessage: '未选择新的标签',
          loadingKey: 'pickLoading'
        }
      );
    },
    resolveIndex(filteredIndex) {
      const filtered = this.filteredTags;
      if (filteredIndex < 0 || filteredIndex >= filtered.length) return -1;
      const item = filtered[filteredIndex];
      return this.tags.findIndex(t => t.id === item.id);
    },
    // 移动标签：排序模式下以“当前显示顺序（优先级升序）”为基准移动，并同步重排优先级
    moveTag(from, to) {
      if (to < 0 || from < 0) return;

      // 排序模式下列表为全量数据，filteredTags 即按 priority 升序的显示顺序
      if (this.sortMode) {
        const ordered = this.filteredTags.slice();
        if (from >= ordered.length) return;
        const insertAt = Math.min(to, ordered.length - 1);
        if (insertAt === from) return;

        const [moved] = ordered.splice(from, 1);
        ordered.splice(insertAt, 0, moved);

        // allTags 是浅拷贝，必须用 id 映射回 this.tags 中的原对象再落优先级
        const tagMap = new Map(this.tags.map(t => [t.id, t]));
        const next = ordered.map(t => tagMap.get(t.id)).filter(Boolean);
        this.tags.splice(0, this.tags.length, ...next);
        // 列表按 priority 升序渲染，不同步重排优先级则移动不会生效
        next.forEach((t, i) => { t.priority = i + 1; });
        return;
      }

      // 非排序模式：保持原有的按筛选后索引映射的移动方式
      const filtered = this.filteredTags;
      const actualFrom = this.resolveIndex(from);
      if (actualFrom === -1) return;

      let actualTo;
      if (to === 0) {
        actualTo = 0;
      } else if (to >= filtered.length) {
        actualTo = this.tags.length;
      } else {
        actualTo = this.resolveIndex(to);
        if (actualTo === -1) return;
      }

      const item = this.tags.splice(actualFrom, 1)[0];
      this.tags.splice(actualTo, 0, item);
    },
    // 输入序号跳转：target 为 0 基索引（tag-card 已做 -1）
    jumpTo(from, target) {
      const filtered = this.filteredTags;
      const targetIdx = Math.min(target, filtered.length - 1);
      if (targetIdx < 0) return;
      // 未发生位移时也强制刷新输入框显示，避免残留用户输入的无效值
      if (targetIdx === from) {
        this.$forceUpdate();
        return;
      }
      this.moveTag(from, targetIdx);
    },
    onDragDrop(from, to) {
      this.moveTag(from, to);
    },
    reorderAll() {
      // 通知父级按当前公司与策略组重新拉取业务标签
      this.onGroupChange();
      this.$message.success('序号已恢复');
    },
    // 排序模式下保存：按当前优先级顺序把标签批量提交后端
    saveSort() {
      // 排序模式下 filteredTags 已为全量且按优先级升序
      const list = this.filteredTags;
      // 缺少明细 id 的标签会导致后端顺序不完整，直接阻断避免脏数据
      if (list.some(t => t.detailId === undefined || t.detailId === null)) {
        this.$message.warning('存在缺少明细ID的标签，无法保存排序');
        return;
      }
      this.submitLabelBatch(
        list.map(t => t.detailId),
        {
          successMessage: '排序已保存',
          emptyMessage: '当前没有可保存的标签',
          loadingKey: 'sortSaving',
          // 静默退出排序模式，避免再触发 reorderAll 的“序号已恢复”提示
          onSuccess: () => {
            this.clearSortMode();
          }
        }
      );
    },
    // 静默清除排序模式（进入页面、离开页面、保存排序后）：
    // 不走 reorderAll 的重新拉取与“序号已恢复”提示，数据由调用方负责刷新
    clearSortMode() {
      if (!this.sortMode) return;
      this.sortModeResetting = true;
      this.sortMode = false;
      // sortMode 监听在 nextTick 才执行，等它跑完后再复位标记
      this.$nextTick(() => {
        this.sortModeResetting = false;
      });
    },
    // 每次点击业务标签 tab 时执行：清除排序模式 -> 重置筛选条件 -> 父级有已选公司则恢复，否则默认选第一家，然后刷新业务标签
    enterBusiness() {
      // 每次进入都退出排序模式，避免带着上次的排序状态进入
      this.clearSortMode();
      // 每次进入业务标签池都重置搜索与来源筛选，避免沿用上次的筛选条件
      this.searchKeyword = '';
      this.sourceFilter = 'all';
      const list = this.companyList;
      if (!list || !list.length) {
        this.pendingEnter = true;
        return;
      }
      this.pendingEnter = false;
      let target = null;
      // 父级记录过已选公司（非空），优先恢复它
      if (this.savedCompany !== null && this.savedCompany !== undefined && this.savedCompany !== '') {
        target = list.find(c => String(c.id) === String(this.savedCompany)) || null;
      }
      if (!target) target = list[0];
      this.selectedCompany = target.id;
      this.onCompanyChange(this.selectedBizType);
    },
    onCompanyChange(savedGroupId) {
      this.$emit('company-change-business', this.selectedCompany);
      this.$emit('company-change-business-type', this.currentCompany.type);
      this.groupReq.companyId = this.selectedCompany;
      this.$ajax({
        url: '/strategy/selectAllGroupsByCompanyIdOfUser',
        method: 'POST',
        data: this.groupReq
      }).then((res) => {
        this.bizTypeList = res.data || [];
        if (this.bizTypeList.length) {
          if (savedGroupId != null) {
            this.selectedBizType = savedGroupId;
          } else {
            this.selectedBizType = this.bizTypeList[0].id;
          }
          // 通知父级按当前公司与策略组重新拉取业务标签
          this.onGroupChange();
        }
      });
    },
    // 开关业务标签池：/label/updateGroupLabelOpen，入参 UpdateStatusReq（companyId/id/status）
    updateGroupLabelStatus(status) {
      const group = this.currentGroup;
      if (!group) return;
      // 开关是 v-model 绑定的，校验不通过或失败时都要回滚到原状态
      const rollback = () => {
        group.isGroupLabelOpen = !status;
      };
      if (this.selectedCompany === null || this.selectedCompany === undefined || this.selectedCompany === '') {
        this.$message.warning('请先选择归属公司');
        rollback();
        return;
      }
      if (this.groupStatusUpdating) {
        rollback();
        return;
      }
      this.groupStatusUpdating = true;
      this.$ajax({
        url: '/label/updateGroupLabelOpen',
        method: 'POST',
        data: {
          companyId: this.selectedCompany,
          // 业务子类型（策略组）id
          id: group.id,
          status: !!status
        }
      })
        .then((res) => {
          this.groupStatusUpdating = false;
          if (!res || res.code !== 200) {
            rollback();
            return;
          }
          this.$message.success(status ? '已开启业务标签池' : '已关闭业务标签池');
          // 通知父级按当前公司与策略组重新拉取业务标签
          this.onGroupChange();
        })
        .catch(() => {
          // 错误提示已由 $ajax 响应拦截器统一弹出，这里只回滚开关
          this.groupStatusUpdating = false;
          rollback();
        });
    },
    onGroupChange() {
      this.$emit('group-change-business', this.selectedBizType);
    }
  }
};
</script>

<style lang="less" scoped>
@import '../../../assets/style/variable.less';

.card-panel {
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 16px;
}

.field-label {
  font-size: 12px;
  font-weight: bold;
  color: #909399;
  text-transform: uppercase;
  letter-spacing: 1px;
  display: block;
  margin-bottom: 8px;
}

// 业务子类型下拉项：开启状态着色
.biz-option__status {
  font-size: 12px;

  &--on {
    color: #67c23a;
  }

  &--off {
    color: #f56c6c;
  }
}

.biz-selectors {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;

  &__item {
    width: 280px;
  }

  &__arrow {
    padding-top: 24px;
  }
}

.biz-stat-card {
  background: linear-gradient(135deg, #7c3aed, #4338ca);
  border-radius: 12px;
  padding: 20px 24px;
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  box-shadow: 0 4px 16px rgba(124, 58, 237, 0.2);

  &__title {
    font-size: 22px;
    font-weight: bold;
    margin: 0 0 4px;
  }

  &__company {
    font-size: 13px;
    opacity: 0.8;
    display: flex;
    align-items: center;
    gap: 4px;
  }

  &__count {
    text-align: right;
  }

  &__number {
    font-size: 36px;
    font-weight: bold;
  }

  &__label {
    font-size: 13px;
    opacity: 0.8;
  }
}

.pool-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  flex-wrap: wrap;
  gap: 8px;

  &__left {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  &__right {
    display: flex;
    align-items: center;
    gap: 8px;
  }
}

.source-filter-btns {
  display: flex;
  background: #fff;
  border: 1px solid #e2e8f0;
  padding: 4px;
  border-radius: 8px;
}

.source-filter-btn {
  padding: 6px 14px;
  border-radius: 6px;
  border: none;
  background: none;
  font-size: 13px;
  font-weight: 600;
  color: #64748b;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #f1f5f9;
  }

  &--active {
    background: #7c3aed;
    color: #fff;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);

    &:hover {
      background: #7c3aed;
    }
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
}

.source-count {
  font-size: 12px;
  color: #c0c4cc;
}

.sort-label {
  font-size: 12px;
  font-weight: bold;
  color: #909399;
}

.sort-hint {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #faf5ff;
  border: 1px solid #ede9fe;
  padding: 10px 16px;
  border-radius: 8px;
  margin-bottom: 12px;
  font-size: 13px;
  color: #7c3aed;
}

.pool-table-header {
  display: flex;
  align-items: center;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 12px 20px;
  font-size: 12px;
  font-weight: bold;
  color: #64748b;
  margin-bottom: 4px;

  &__col {
    display: flex;
    align-items: center;

    &--30 { width: 30%; }
    &--15 { width: 15%; justify-content: center; }
    &--20 { width: 20%; justify-content: center; }
    &--35 { width: 35%; }
    &--right { justify-content: flex-end; }
  }

  &__rank {
    width: 64px;
    flex-shrink: 0;
  }
}

.pool-list {
  min-height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/page/main/tagpools/business-pool.vue